import { ModelBase, Property } from '@skylab-shared/core';
import { SaleDocumentKind } from '@skylab-shared/dataModel';

export class OrderSaleDocumentModel extends ModelBase {
	@Property({nullable: true})
	public id!: string;

	@Property({nullable: true})
	public kind!: SaleDocumentKind;

	@Property({nullable: true})
	public saleDocExternalId!: string;

	@Property({nullable: true})
	public saleDocNumber!: string;
}
